import React from 'react';
import { Helmet } from "react-helmet";

const RefundPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Ecunel Fitness Gym - Το Καλύτερο Blog για Fitness</title>
        <meta name="description" content="Ecunel Fitness Gym - Το καλύτερο blog για fitness, προπονήσεις και υγιεινή ζωή στην Ελλάδα" />
      </Helmet>

      <div className="policy-container">
      <div className="policy-content">
        <h1>Πολιτική Επιστροφών και Χρημάτων</h1>
        <p className="last-updated">Τελευταία ενημέρωση: {new Date().toLocaleDateString('el-GR')}</p>

        <section>
          <h2>1. Εισαγωγή</h2>
          <p>
            Ευχαριστούμε που επιλέξατε το Ecunel Fitness Gym. Αυτή η πολιτική επιστροφών και χρημάτων περιγράφει 
            τις πολιτικές και τις διαδικασίες μας σχετικά με τις επιστροφές χρημάτων και τις ακυρώσεις για τις 
            υπηρεσίες και τα προϊόντα που προσφέρουμε.
          </p>
          <p>
            Παρακαλούμε διαβάστε προσεκτικά αυτή την πολιτική επιστροφών πριν πραγματοποιήσετε οποιαδήποτε αγορά 
            ή εγγραφή στις υπηρεσίες μας.
          </p>
        </section>

        <section>
          <h2>2. Δωρεάν Περιεχόμενο και Υπηρεσίες</h2>
          <p>
            Το Ecunel Fitness Gym είναι κυρίως ένα blog που προσφέρει δωρεάν περιεχόμενο σχετικά με fitness, 
            προπονήσεις, διατροφή και υγιεινή ζωή. Η πρόσβαση στο περιεχόμενο του blog είναι εντελώς δωρεάν 
            και δεν απαιτείται πληρωμή.
          </p>
          <p>
            Για το δωρεάν περιεχόμενο, δεν εφαρμόζεται πολιτική επιστροφών καθώς δεν υπάρχει καμία χρέωση.
          </p>
        </section>

        <section>
          <h2>3. Πληρωμένες Υπηρεσίες (εάν υπάρχουν)</h2>
          <p>
            Εάν στο μέλλον προσφέρουμε πληρωμένες υπηρεσίες όπως premium περιεχόμενο, προγράμματα προπόνησης, 
            διατροφικά σχέδια ή online coaching, θα ισχύουν οι ακόλουθοι όροι:
          </p>

          <h3>3.1 Περίοδος Δοκιμαστικής Χρήσης</h3>
          <p>
            Εάν προσφέρουμε δωρεάν δοκιμαστική περίοδο, έχετε το δικαίωμα να ακυρώσετε ανά πάσα στιγμή κατά 
            τη διάρκεια της δοκιμαστικής περιόδου χωρίς χρέωση. Μετά το τέλος της δοκιμαστικής περιόδου, θα 
            χρεωθείτε αυτόματα εκτός εάν ακυρώσετε πριν από το τέλος της.
          </p>

          <h3>3.2 Μηνιαίες Συνδρομές</h3>
          <p>
            Για μηνιαίες συνδρομές, μπορείτε να ακυρώσετε ανά πάσα στιγμή. Η ακύρωση θα τεθεί σε ισχύ στο τέλος 
            της τρέχουσας περιόδου χρέωσης. Δεν προσφέρουμε αναλογικές επιστροφές χρημάτων για μερική χρήση 
            του μήνα.
          </p>

          <h3>3.3 Ετήσιες Συνδρομές</h3>
          <p>
            Για ετήσιες συνδρομές, προσφέρουμε εγγύηση επιστροφής χρημάτων 30 ημερών. Εάν δεν είστε ικανοποιημένοι 
            με την υπηρεσία μας εντός των πρώτων 30 ημερών από την αγορά, μπορείτε να ζητήσετε πλήρη επιστροφή 
            χρημάτων. Μετά την περίοδο των 30 ημερών, δεν προσφέρονται επιστροφές χρημάτων, αλλά μπορείτε να 
            ακυρώσετε για να αποφύγετε μελλοντικές χρεώσεις.
          </p>
        </section>

        <section>
          <h2>4. Ψηφιακά Προϊόντα</h2>
          <p>
            Εάν προσφέρουμε ψηφιακά προϊόντα όπως e-books, προγράμματα προπόνησης, διατροφικούς οδηγούς ή 
            video μαθήματα, ισχύουν οι ακόλουθοι όροι:
          </p>

          <h3>4.1 Εγγύηση Επιστροφής Χρημάτων</h3>
          <p>
            Προσφέρουμε εγγύηση επιστροφής χρημάτων 14 ημερών για όλα τα ψηφιακά προϊόντα. Εάν δεν είστε 
            ικανοποιημένοι με το προϊόν σας εντός 14 ημερών από την αγορά, μπορείτε να ζητήσετε πλήρη επιστροφή 
            χρημάτων.
          </p>

          <h3>4.2 Προϋποθέσεις για Επιστροφή Ψηφιακών Προϊόντων</h3>
          <p>Για να είστε επιλέξιμοι για επιστροφή χρημάτων για ψηφιακά προϊόντα, πρέπει:</p>
          <ul>
            <li>Να υποβάλετε το αίτημά σας εντός 14 ημερών από την ημερομηνία αγοράς</li>
            <li>Να δώσετε έναν λόγο για την επιστροφή</li>
            <li>Να μην έχετε παραβιάσει τους όρους χρήσης μας</li>
            <li>Να μην έχετε κάνει κατάχρηση της πολιτικής επιστροφών μας στο παρελθόν</li>
          </ul>
        </section>

        <section>
          <h2>5. Υπηρεσίες Coaching και Συμβουλευτικής</h2>
          <p>
            Για εξατομικευμένες υπηρεσίες coaching ή συμβουλευτικής:
          </p>

          <h3>5.1 Ακύρωση Πριν την Έναρξη</h3>
          <p>
            Μπορείτε να ακυρώσετε τις υπηρεσίες coaching πριν από την πρώτη συνεδρία για πλήρη επιστροφή χρημάτων.
          </p>

          <h3>5.2 Ακύρωση Μετά την Έναρξη</h3>
          <p>
            Μετά την πρώτη συνεδρία, οι επιστροφές θα υπολογίζονται αναλογικά με βάση τον αριθμό των 
            χρησιμοποιημένων συνεδριών. Μια προμήθεια διαχείρισης 20% μπορεί να εφαρμοστεί.
          </p>

          <h3>5.3 Χαμένες Συνεδρίες</h3>
          <p>
            Οι συνεδρίες που ακυρώνονται με λιγότερο από 24 ώρες προειδοποίηση θεωρούνται χρησιμοποιημένες 
            και δεν επιστρέφονται.
          </p>
        </section>

        <section>
          <h2>6. Διαδικασία Αιτήματος Επιστροφής Χρημάτων</h2>
          <p>
            Για να ζητήσετε επιστροφή χρημάτων, ακολουθήστε τα παρακάτω βήματα:
          </p>
          <ol>
            <li>Στείλτε email στο <a href="mailto:ecunel@hotmail.com">ecunel@hotmail.com</a> με το θέμα "Αίτημα Επιστροφής Χρημάτων"</li>
            <li>Συμπεριλάβετε τον αριθμό παραγγελίας σας και την ημερομηνία αγοράς</li>
            <li>Δώστε μια σύντομη εξήγηση για τον λόγο της επιστροφής</li>
            <li>Θα επεξεργαστούμε το αίτημά σας εντός 5-7 εργάσιμων ημερών</li>
            <li>Εάν εγκριθεί, η επιστροφή θα πιστωθεί στην αρχική σας μέθοδο πληρωμής εντός 10-14 εργάσιμων ημερών</li>
          </ol>
        </section>

        <section>
          <h2>7. Μη Επιστρέψιμα Στοιχεία</h2>
          <p>
            Ορισμένα στοιχεία και υπηρεσίες δεν είναι επιστρέψιμα:
          </p>
          <ul>
            <li>Υπηρεσίες που έχουν ολοκληρωθεί πλήρως</li>
            <li>Προϊόντα που αγοράστηκαν σε έκπτωση πάνω από 50%</li>
            <li>Δωροεπιταγές ή πιστωτικά</li>
            <li>Ειδικά προϊόντα που παρήχθησαν κατόπιν παραγγελίας</li>
            <li>Τρίτες υπηρεσίες ή προϊόντα που αγοράστηκαν μέσω του ιστότοπού μας</li>
          </ul>
        </section>

        <section>
          <h2>8. Καθυστερημένες ή Χαμένες Επιστροφές</h2>
          <p>
            Εάν δεν έχετε λάβει επιστροφή χρημάτων ακόμη, ελέγξτε πρώτα ξανά τον τραπεζικό σας λογαριασμό. 
            Στη συνέχεια, επικοινωνήστε με την εταιρεία της πιστωτικής σας κάρτας, μπορεί να χρειαστεί λίγος 
            χρόνος πριν η επιστροφή σας αναρτηθεί επίσημα.
          </p>
          <p>
            Στη συνέχεια, επικοινωνήστε με την τράπεζά σας. Συχνά υπάρχει κάποιος χρόνος επεξεργασίας πριν 
            από την ανάρτηση μιας επιστροφής. Εάν έχετε κάνει όλα αυτά και ακόμα δεν έχετε λάβει την επιστροφή 
            σας, επικοινωνήστε μαζί μας στο <a href="mailto:ecunel@hotmail.com">ecunel@hotmail.com</a>.
          </p>
        </section>

        <section>
          <h2>9. Ανταλλαγές</h2>
          <p>
            Αντικαθιστούμε μόνο προϊόντα εάν είναι ελαττωματικά ή κατεστραμμένα. Εάν χρειάζεται να το 
            αντικαταστήσετε με το ίδιο προϊόν, στείλτε μας email στο <a href="mailto:ecunel@hotmail.com">ecunel@hotmail.com</a> και στείλτε το 
            προϊόν σας στη διεύθυνσή μας.
          </p>
        </section>

        <section>
          <h2>10. Τεχνικά Προβλήματα</h2>
          <p>
            Εάν αντιμετωπίζετε τεχνικά προβλήματα με τις υπηρεσίες ή τα ψηφιακά προϊόντα μας:
          </p>
          <ul>
            <li>Επικοινωνήστε πρώτα με την ομάδα υποστήριξής μας στο <a href="mailto:ecunel@hotmail.com">ecunel@hotmail.com</a></li>
            <li>Θα καταβάλουμε κάθε δυνατή προσπάθεια να επιλύσουμε το πρόβλημα εντός 48 ωρών</li>
            <li>Εάν το πρόβλημα δεν μπορεί να επιλυθεί, μπορεί να έχετε δικαίωμα επιστροφής χρημάτων</li>
          </ul>
        </section>

        <section>
          <h2>11. Κατάχρηση Πολιτικής Επιστροφών</h2>
          <p>
            Διατηρούμε το δικαίωμα να αρνηθούμε επιστροφές ή να αναστείλουμε λογαριασμούς που καταχρώνται την 
            πολιτική επιστροφών μας. Τα παραδείγματα κατάχρησης περιλαμβάνουν:
          </p>
          <ul>
            <li>Πολλαπλά αιτήματα επιστροφής για το ίδιο είδος προϊόντος</li>
            <li>Αιτήματα επιστροφής για περισσότερο από το 50% των αγορών</li>
            <li>Αιτήματα επιστροφής αφού έχετε καταναλώσει ολόκληρο το περιεχόμενο ή την υπηρεσία</li>
            <li>Παροχή ψευδών πληροφοριών σε αιτήματα επιστροφής</li>
          </ul>
        </section>

        <section>
          <h2>12. Τροποποιήσεις της Πολιτικής</h2>
          <p>
            Διατηρούμε το δικαίωμα να τροποποιήσουμε αυτήν την πολιτική επιστροφών ανά πάσα στιγμή. Οι αλλαγές 
            τίθενται σε ισχύ αμέσως μετά τη δημοσίευσή τους στον ιστότοπο. Η συνεχιζόμενη χρήση των υπηρεσιών 
            μας μετά από αλλαγές σημαίνει την αποδοχή της αναθεωρημένης πολιτικής.
          </p>
        </section>

        <section>
          <h2>13. Επικοινωνία</h2>
          <p>
            Εάν έχετε οποιεσδήποτε ερωτήσεις σχετικά με την πολιτική επιστροφών μας, επικοινωνήστε μαζί μας:
          </p>
          <ul>
            <li>Email για Επιστροφές: <a href="mailto:ecunel@hotmail.com">ecunel@hotmail.com</a></li>
            <li>Email Υποστήριξης: <a href="mailto:ecunel@hotmail.com">ecunel@hotmail.com</a></li>
            <li>Ιστότοπος: https://ecunel.com</li>
          </ul>
          <p>
            Η ομάδα υποστήριξής μας είναι διαθέσιμη Δευτέρα-Παρασκευή, 9:00-17:00 (EEST) και θα απαντήσουμε 
            στο αίτημά σας εντός 24-48 ωρών.
          </p>
        </section>

        <section>
          <h2>14. Αποδοχή Όρων</h2>
          <p>
            Πραγματοποιώντας μια αγορά ή εγγραφή στις υπηρεσίες μας, επιβεβαιώνετε ότι έχετε διαβάσει, 
            κατανοήσει και συμφωνήσει με αυτήν την πολιτική επιστροφών και χρημάτων.
          </p>
        </section>
      </div>
    </div>
  
    </>);
};

export default RefundPolicy;